/* eslint-disable @typescript-eslint/no-explicit-any */
import { reactive, watch } from 'vue'

function get(storage: Storage, id: string) {
  return JSON.parse(storage.getItem(id) ?? 'null')
}
function set(storage: Storage, id: string, data: any) {
  storage.setItem(id, JSON.stringify(data))
}

const sessionMap: Map<string, Record<string, unknown>> = new Map()
const localMap: Map<string, Record<string, unknown>> = new Map()

function useState<T = Record<string, unknown>>(
  storageType: 'local' | 'session',
  id: string,
  initialState: T = {} as unknown as T,
): T {
  const storage = storageType === 'local' ? localStorage : sessionStorage
  const stateMap = storageType === 'local' ? localMap : sessionMap

  function createWatch(stateToWatch: T) {
    watch(
      () => stateToWatch,
      s => {
        set(storage, id, s)
      },
      {
        deep: true,
      },
    )
  }
  const existingState = stateMap.get(id) as T
  if (existingState) {
    createWatch(existingState)
    return existingState
  }

  const state: T = reactive(initialState as any)
  const prevState = get(storage, id)
  if (prevState) {
    for (const [k, v] of Object.entries(prevState)) {
      state[k as keyof T] = v as any
    }
  } else {
    set(storage, id, initialState)
  }

  createWatch(state)

  stateMap.set(id, state as Record<string, unknown>)

  return state
}

export function useSessionState<T = Record<string, unknown>>(
  id: string,
  initialState: T = {} as unknown as T,
): T {
  return useState('session', id, initialState)
}
export function useLocalState<T = Record<string, unknown>>(
  id: string,
  initialState: T = {} as unknown as T,
): T {
  return useState('local', id, initialState)
}
